<template>
  <div class="warning-message">
    <span class="message-all">{{ warningMessage }}</span>
    <div @click="onCopyTraceId" class="link-href">
      <span class="link-href-traceId">{{ traceId }}</span>
      <i class="el-icon-copy-document link-href-icon"></i>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'

export default {
  name: 'warningTip',
  props: {
    warningMessage: {
      type: String,
      default: ''
    },
    traceId: {
      type: String,
      default: ''
    }
  },
  methods: {
    onCopyTraceId() {
      const textareaEl = document.createElement('textarea')
      textareaEl.value = this.traceId
      document.body.appendChild(textareaEl)
      textareaEl.select() // 自动选中
      document.execCommand('copy')
      document.body.removeChild(textareaEl)
      Message.success({
        customClass: 'success-message-class',
        message: '复制成功',
        type: 'success'
      })
    }
  }
}
</script>

<style lang="stylus">
.warning-message-class {
  padding: 0 15px;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.12), 0px -2px 4px 0px rgba(0,0,0,0.04);
  border-radius: 4px;
  min-width: auto;
}
.warning-icon {
  font-size: 16px;
  color: #ff781e !important;
  margin-right 8px
}
.success-message-class{
  padding: 10px 15px;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 0px rgba(0,0,0,0.12), 0px -2px 4px 0px rgba(0,0,0,0.04);
  border-radius: 4px;
  min-width: auto;
  color: #161616;
  .el-icon-success {
    color: #ff781e;
    font-size: 16px
  }
  .el-message__content {
    color: #161616;
  }
}
</style>
<style lang="stylus" scoped>
.warning-message {
  display: flex;
  .message-all {
    padding: 10px 0 !important;
    font-size: 14px;
    color: #161616;
    max-width: 400px;
    word-break: break-all;
  }
  .link-href {
    margin auto 0;
    margin-left: 16px;
    cursor: pointer;
    padding: 11px 0 !important;
    &:hover {
      .link-href-traceId {
        color: #1F5DE9;
      }
      .link-href-icon {
        color: #1F5DE9;
      }
    }
    .link-href-traceId {
      font-size: 12px;
      color: #6F6F6F;
      line-height: 20px;
    }
    .link-href-icon {
      margin-left: 8px;
      color: #6F6F6F;
      font-size: 16px
    }
  }
}
</style>
